import React from 'react';
const HomePage = () => {
  return (
    <div className="container">
      <br />
      <div className="jumbotron bg-light">
        <h1>FCAS pays (BETA)</h1>
        <p>
          This web application is under active development, therefore some
          functionality may not work as expected.
        </p>
        <p>Data is only available from 01 Jan 2011 - 31 July 2017.</p>
        <p>
          If you have any requests or ideas to share, feel free to{' '}
          <a
            href="http://pdview.com.au/contact?ref=fcas-pays"
            target="_blank"
            rel="noopener noreferrer"
          >
            contact us
          </a>.
        </p>
        <hr className="my-4" />
        <h4>To start, click on reports or core data in the menu</h4>
      </div>
    </div>
  );
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/views/home/HomePage.jsx